//TODO: add onEnter to the appLayout.harriSH.adam route to check the service and the permission.
export const AdamRoutes = [
    {
        "url": "/adam",
        "name": "appLayout.harriSH.adam",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "abstract": true,
        "params": {},
        "component": "adamContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["adam"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/adam/adam.downgrade.module");
                }
            },
        ],
    },
    {
        "url": "/views?view",
        "name": "appLayout.harriSH.adam.views",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "params": {
            view: {
                dynamic: true,
            },
        },
        "views": {
            'adam': {
                'component': 'adamViewsContainer'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["adam"]
        },
        "route_dependencies": []
    },
    {
        "url": "/operations/:operationId",
        "name": "appLayout.harriSH.adam.operation",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "params": {},
        "views": {
            'adam': {
                'component': 'adamOperationContainer'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["adam"]
        },
        "route_dependencies": []
    },
    {
        "url": "/address-confirm",
        "name": "appLayout.harriSH.adam.address-confirm",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "params": {},
        "views": {
            'adam': {
                'component': 'adamAddressConfirmContainer'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["adam"]
        },
        "route_dependencies": []
    },
    {
        "url": "/compliance-review?operationId&operationType",
        "name": "appLayout.harriSH.adam.compliance-review",
        "type": "frontend",
        "showGlobalSearch": true,
        "platformPage": true,
        "loginRequired": true,
        "params": {
            operationId: {
                dynamic: true,
            },
        },
        "views": {
            'adam': {
                'component': 'adamComplianceReviewContainer'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["adam", "settings_forms_wrapper", "tl_compliance_settings"]
        },
        "route_dependencies": []
    }
];
//# sourceMappingURL=adam.routes.js.map